module.exports = __webpack_public_path__ + "media/images/favorite-icon-filled-0bee2babc7a3be3b25bedc4dc5d17554.png";